<template>
  <div class="blocpromo">
    <div class="page">
      <div id="promoApp">
        <div id="navprev"><a @click="prev"><img src="http://638ad42bcb.testurl.ws/mihotel/img/prevpromo.png"></a></div>
        <div id="navnext"><a @click="next"><img src="http://638ad42bcb.testurl.ws/mihotel/img/nextpromo.png"></a></div>
        <ul id="sliderpromo">
          <transition-group name="slide">
            <li id="slidepromo"
                v-for="imgObj in images"
                :key="imgObj"
                :class="{ active: imgObj === active }"
            >
              <div class="gradientpromo"></div>
              <img :src="fond[imgObj - 1]"/>
              <div class="textpromo"><h3>Offre Business</br>Bienvenue au Club MiHotel</h3>
                <p>Adhérez au club MiHotel pour les tarifs business personnalisés</p></div>
            </li>
          </transition-group>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'home-discounts',
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/home/home-discounts.vue